import css from 'styled-jsx/css';

export default css`
  .image-wrapper {
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
  }

  :global(.rtl) .image-wrapper {
    left: auto;
    right: 50%;
    transform: translateX(50%);
  }

  .image-wrapper.is-maker {
    bottom: 0;
    height: auto;
    top: 0;
    width: 100%;
    position: absolute;
    margin: auto;
  }

  .image-wrapper.is-hero {
    left: 0;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }

  :global(.rtl) .image-wrapper.is-hero {
    right: 0;
  }

  .image-wrapper.hidden {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./app/components/shared/Images/Image/styles.js